// FormThree.js
import React from "react";
import { Field, formValueSelector, reduxForm } from "redux-form";
import validate from "./validate";
import Input from "../../../../components/ReduxForm/Input";
import { useSelector } from "react-redux";
import { Spinner } from "reactstrap";
import TextArea from "components/ReduxForm/TextArea";
import renderCheckBoxField from "shared/components/form/CheckBox";

const FormThree = props => {
	const {
		handleSubmit,
		pristine,
		submitting,
		previousPage,
		onFormThreeSubmit,
		change
	} = props;

	const state = useSelector(state => state);

	const selector = formValueSelector("expositor_form");

	const loading = selector(state, "loading");
	const pcd = selector(state, "pcd");

	const type = selector(state, "type");

	const handleNextClick = async event => {
		event.preventDefault();
		handleSubmit(onFormThreeSubmit);
	};

	return (
		<div>
			<form className="form" onSubmit={handleNextClick}>
				<div className="form__form-group">
					<div style={{ display: "flex" }}>
						<div style={{ flex: 3, marginRight: 4 }}>
							<span className="form__form-group-label">Cidade</span>
							<div className="form__form-group-field">
								<Field
									name="city"
									type="text"
									placeholder="Ex.: Florianópolis"
									component={Input}
									key="city"
								/>
							</div>
						</div>
						<div style={{ flex: 1, marginLeft: 4 }}>
							<span className="form__form-group-label">Estado</span>
							<div className="form__form-group-field">
								<Field
									name="state"
									type="text"
									placeholder="Ex.: SC"
									component={Input}
									key="state"
								/>
							</div>
						</div>
					</div>
					{/* <br /> */}
					{/* <span className="form__form-group-label">Selecione uma opção</span> */}
					<br />
					<div
						className="form__form-group-field"
						// style={{ justifyContent: "space-around" }}
					>
						<Field
							name="pcdFamily"
							component={renderCheckBoxField}
							type="text"
							label="Família de pessoa com deficiência"
						/>
					</div>
					{/* <br />
					<span className="form__form-group-label">Selecione uma opção</span> */}
					<br />
					<div
						className="form__form-group-field"
						// style={{ justifyContent: "space-around" }}
					>
						<Field
							name="pcd"
							component={renderCheckBoxField}
							type="text"
							label="Pessoa com deficiência"
						/>
					</div>

					{/* <span className="form__form-group-label">Selecione uma opção</span>{" "} */}

					<br />
					<div
						className="form__form-group-field"
						// style={{ justifyContent: "space-around" }}
					>
						<Field
							name="other"
							component={renderCheckBoxField}
							type="text"
							label="Outro"
						/>
					</div>
					<br />
					{pcd && (
						<>
							<span className="form__form-group-label">
								Se você necessita de atendimento especial, por favor, informe
							</span>
							<div className="form__form-group-field">
								<Field
									name="specialNeeds"
									component={TextArea}
									type="text"
									placeholder="Ex.: Intérprete de Libras, Audiodescrição, etc."
								/>
							</div>
							<br />
						</>
					)}
					{["family"].includes(type) && (
						<>
							<span className="form__form-group-label">
								Selecione uma opção
							</span>
							<br />
							<div
								className="form__form-group-field"
								style={{ justifyContent: "space-around" }}
							>
								<Field
									name="provincial"
									component={renderCheckBoxField}
									type="text"
									label="Coordenador Estadual"
									onChange={() => {
										change("region", false);
										change("local", false);
									}}
								/>
								<Field
									name="region"
									component={renderCheckBoxField}
									type="text"
									label="Coordenador Regional"
									onChange={() => {
										change("provincial", false);
										change("local", false);
									}}
								/>
								<Field
									name="local"
									component={renderCheckBoxField}
									type="text"
									label="Coordenador Local"
									onChange={() => {
										change("provincial", false);
										change("region", false);
									}}
								/>
							</div>
						</>
					)}
				</div>

				{/* Campo oculto para enviar o status como 'ativo' */}
				{/* <Field name="status" component="input" type="hidden" value="ativo" /> */}

				<div className="account__btn__group">
					<button
						type="button"
						className="btn btn-primary account__btn account__btn--small"
						onClick={previousPage}
					>
						Voltar
					</button>
					<button
						type="submit"
						className="btn btn-primary account__btn account__btn--small"
						disabled={pristine || submitting || loading}
					>
						{loading ? (
							<Spinner type="grow" size="sm" color="dark" />
						) : (
							"Próximo"
						)}
					</button>
				</div>
			</form>
		</div>
	);
};

export default reduxForm({
	form: "expositor_form",
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate: v => validate(v, 3),
	initialValues: {
		status: "ativo"
	}
})(FormThree);
